// Clerk keeps a readable `__client_uat` cookie (suffixed per instance) whose
// value is 0 when nobody is signed in. Reading it lets the first paint guess
// the visitor's state while Clerk itself is still loading.
export function hasSessionHint() {
  if (typeof document === "undefined") return false;
  return document.cookie.split(";").some((part) => {
    const [name, value] = part.trim().split("=");
    return name.startsWith("__client_uat") && Boolean(value) && value !== "0";
  });
}
